import templateHtml from './hellosign-embedded-iframe.component.html';
import { $safeApply } from '@buildium/angularjs-core/dist/utilities/angularjs';

export const HelloSignIframeErrorHash = '637b29fb44dd46d598afbbd320f7cda4';
const component = {};
component.template = templateHtml;
component.controllerAs = 'vm';

component.bindings = {
    embedUrl: '<',
    onHellosignActionTaken: '&',
    hellosignActionEvent: '@', // HELLOSIGN_CLIENT_EVENT enum
    onHellosignReadyEvent: '&?', // Optional callback for when the HelloSign iFrame emits the ready event
    clientConfigApiFunc: '<'
};

component.controller = function bdHellosignEmbeddedIframeComponent(
    $scope,
    HelloSignClientService,
    HELLOSIGN_CLIENT_EVENT,
    Notify,
    LoggingApi
) {
    const vm = this;

    function logError(errorData) {
        const errorToLog = {
            Message: JSON.stringify(errorData),
            Hash: HelloSignIframeErrorHash,
            Location: 'bdHellosignEmbeddedIframe.on.helloSignErrorEvent'
        };
        LoggingApi.logError(errorToLog);
    }

    function initializeHelloSign(clientConfiguration) {
        HelloSignClientService.createClient(clientConfiguration, 'hellosign_container');
        HelloSignClientService.onReady(() => {
            $safeApply($scope, () => {
                vm.isLoading = false;
                if (vm.onHellosignReadyEvent) {
                    vm.onHellosignReadyEvent();
                }
            });
        });
        HelloSignClientService.open(vm.embedUrl);
        HelloSignClientService.setOneTimeHelloSignEventListener(vm.hellosignActionEvent, (data) => {
            $safeApply($scope, () => {
                vm.isLoading = true;
                vm.onHellosignActionTaken({helloSignData: data});
                HelloSignClientService.close();
            });
        });
        HelloSignClientService.setOneTimeHelloSignEventListener(HELLOSIGN_CLIENT_EVENT.Error, (data) => {
            $safeApply($scope, () => {
                vm.isLoading = false;
                logError(data);
                Notify.error('Oops, something went wrong!');
                HelloSignClientService.close();
            });
        });
    }

    vm.$onInit = function onInit() {
        vm.isLoading = true;

        vm.clientConfigApiFunc()
            .then((clientConfiguration) => {
                initializeHelloSign(clientConfiguration);
            });
    };

    vm.$onDestroy = function onDestroy() {
        HelloSignClientService.close();
    };
};

component.controller.$inject = [
    '$scope',
    'HelloSignClientService',
    'HELLOSIGN_CLIENT_EVENT',
    'Notify',
    'LoggingApi'
];

export const HellosignEmbeddedIframeComponent = component;
